import { ReactNode } from "react";
import { Table } from "react-bootstrap";
import "./CommonTable.scss";

type TProps = {
  children?: ReactNode;
  fields?: any;
  tableTitle?: string;
};

const CommonTable = (props: TProps) => {
  return (
    <>
      <div className="table_box">
        <h5 className="table_heading">{props.tableTitle}</h5>
        <div className="table_box_in">
          <Table responsive>
            {props.fields && (
              <thead>
                <tr>
                  {props.fields?.map((item: any) => {
                    return <th key={item}>{item}</th>;
                  })}
                </tr>
              </thead>
            )}
            <tbody>
              {props.children || (
                <tr>
                  <td colSpan={props.fields?.length} className="no_record">
                    <div className="no_record_box">
                      {/* <NoRecord /> */}
                      No Record Found
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
    </>
  );
};

export default CommonTable;
